import { useCallback, useState } from "react";
import AcademyAPI from "../services/academyService";

export const useEnrollCourse = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const enroll = useCallback(async (courseId) => {
        if (!courseId) {
            throw new Error("courseId es requerido");
        }
        setLoading(true);
        setError(null);

        try {
            const response = await AcademyAPI.enrollCourse(courseId);
            return response;
        } catch (err) {
            const msg = err?.message || "Error inscribiendo al curso";
            setError(msg);
            throw new Error(msg);
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        enroll,
        loading,
        error,
    };
};
